import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  t1: number; // Largeur trottoir 1
  t2: number; // Largeur trottoir 2
  c: number; // Largeur chaussée
  b: number; // Biais
  L: number; // Longueur
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.SLAB_BRIDGE_EXTRADOS,
  image: "/images/assets/pont-dalle-extrados.png",
  submittedBy: SubmittingOrganization.ARS,
  inputs: [
    {
      key: "t1",
      type: "dimension",
    },
    {
      key: "t2",
      type: "dimension",
    },
    {
      key: "c",
      type: "dimension",
    },
    {
      key: "b",
      type: "angle",
    },
    {
      key: "L",
      type: "dimension",
    },
  ],
  build: (params, offset) => {
    const { t1, t2, c, b, L } = params;
    const bRad = (b * Math.PI) / 180;
    const w = c + t1 + t2;
    return [
      {
        // center parallelogram
        type: "polyline",
        points: [
          [
            // bottom Left
            offset[0] - w / 2,
            offset[1] - L / 2 - (w / 2) * Math.tan(bRad),
            offset[2],
          ],
          [
            // bottom right
            offset[0] + w / 2,
            offset[1] - L / 2 + (w / 2) * Math.tan(bRad),
            offset[2],
          ],
          [
            // top right
            offset[0] + w / 2,
            offset[1] + L / 2 + (w / 2) * Math.tan(bRad),
            offset[2],
          ],
          [
            // top left
            offset[0] - w / 2,
            offset[1] + L / 2 - (w / 2) * Math.tan(bRad),
            offset[2],
          ],
          [
            // bottom Left
            offset[0] - w / 2,
            offset[1] - L / 2 - (w / 2) * Math.tan(bRad),
            offset[2],
          ],
        ],
      },
      {
        // trottoir left
        type: "polyline",
        points: [
          [
            // bottom
            offset[0] - c / 2,
            offset[1] - L / 2 - (c / 2) * Math.tan(bRad),
            offset[2],
          ],
          [
            // top
            offset[0] - c / 2,
            offset[1] + L / 2 - (c / 2) * Math.tan(bRad),
            offset[2],
          ],
        ],
      },
      {
        // trottoir right
        type: "polyline",
        points: [
          [
            // bottom
            offset[0] + c / 2,
            offset[1] - L / 2 + (c / 2) * Math.tan(bRad),
            offset[2],
          ],
          [
            // top
            offset[0] + c / 2,
            offset[1] + L / 2 + (c / 2) * Math.tan(bRad),
            offset[2],
          ],
        ],
      },
    ];
  },
};

export default asset;
